var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValueProposition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3416 4939 l-26 -20 0 -193 c0 -188 1 -193 23 -214 45 -42 117 -20 132 41 4 13 5 99 3 191 l-3 168 -28 24 c-34 29 -66 31 -101 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2650 4743 c-30 -11 -60 -47 -60 -72 0 -25 151 -302 182 -333 20 -20 69 -24 98 -8 10 5 23 23 28 40 10 26 7 38 -22 93 -50 96 -144 253 -158 264 -18 15 -50 22 -68 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4231 4737 c-34 -17 -200 -301 -201 -343 0 -61 93 -102 132 -56 8 9 52 81 97 158 96 167 103 207 40 239 -34 18 -37 18 -68 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2818 3938 c11 -18 70 -125 132 -238 62 -113 118 -211 124 -218 12 -12 12 -13 185 376 l50 112 -255 0 -256 0 20 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3630 3963 c0 -11 209 -476 218 -485 6 -6 48 67 240 414 l43 78 -250 0 c-138 0 -251 -3 -251 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3451 3893 c-60 -128 -231 -516 -231 -523 0 -10 482 -15 492 -5 5 6 -227 533 -241 548 -4 4 -13 -5 -20 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2528 3630 c-76 -137 -138 -254 -138 -260 0 -6 96 -10 280 -10 154 0 280 3 280 6 0 7 -280 514 -283 514 -1 0 -64 -112 -139 -250z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4124 3629 c-76 -139 -140 -256 -142 -261 -2 -4 125 -8 282 -8 157 0 286 2 286 4 0 7 -271 499 -280 509 -3 4 -69 -106 -146 -244z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2427 3177 c70 -88 905 -1097 908 -1097 3 0 2 6 0 13 -2 6 -68 244 -145 527 -77 283 -145 530 -151 548 l-11 32 -310 0 -309 0 18 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3203 3178 c29 -115 262 -956 264 -954 2 2 64 222 137 490 l133 486 -270 0 -269 0 5 -22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3900 3195 c0 -2 -68 -251 -150 -552 -83 -301 -149 -550 -148 -553 3 -6 868 1036 907 1091 13 19 9 19 -298 19 -171 0 -311 -2 -311 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818 2030 c-26 -4 -82 -23 -125 -42 -118 -51 -815 -458 -811 -474 5 -21 432 -774 440 -774 3 0 49 25 102 55 52 30 102 55 111 55 9 0 276 -70 593 -155 317 -85 609 -162 647 -171 84 -19 204 -14 285 12 33 11 382 220 890 532 459 283 849 525 867 538 44 33 67 99 60 169 -19 190 -209 225 -480 89 -38 -20 -272 -154 -521 -298 -525 -307 -534 -311 -634 -337 -158 -40 -325 -18 -777 106 -258 70 -275 79 -275 139 0 39 35 76 72 76 14 0 106 -23 204 -51 297 -84 422 -112 472 -105 84 11 135 61 148 143 14 92 -55 179 -161 202 -157 33 -306 75 -485 136 -484 165 -518 173 -622 155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 1649 c-140 -80 -160 -95 -160 -119 0 -16 735 -1325 761 -1357 20 -23 46 -14 176 59 155 86 166 95 161 128 -4 25 -727 1310 -755 1343 -9 9 -26 17 -37 17 -12 0 -77 -32 -146 -71z m159 -135 c25 -21 31 -33 31 -65 0 -96 -121 -124 -165 -38 -30 57 15 127 82 129 12 0 35 -12 52 -26z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueProposition);
export default __webpack_public_path__ + "static/media/value-proposition.cb8737988f3ef72482808a2386c2803e.svg";
export { ForwardRef as ReactComponent };